import { RowSelectionState, OnChangeFn } from "@tanstack/react-table";
import { ReactNode } from "react";
import { View } from "@common/types/views/views";
import { ServiceTemplateScheduleOccurrencesSortValue } from "@common/types/views/serviceTemplateScheduleOccurrencesView";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import type { ServiceTemplateScheduleOccurrenceRow } from "./serviceTemplateScheduleOccurrencesViewConfig";
import type {
    ServiceTemplateScheduleOccurrenceCallbacks,
    ServiceTemplateScheduleOccurrenceTableOptions,
} from "./serviceTemplateScheduleOccurrenceCallbacks";
import { serviceTemplateScheduleOccurrencesViewConfig } from "./serviceTemplateScheduleOccurrencesViewConfig";
import { serviceTemplateScheduleOccurrencesView } from "./serviceTemplateScheduleOccurrencesView.constants";

interface Props {
    rows: ServiceTemplateScheduleOccurrenceRow[];
    view?: View;
    tableMeta?: ViewTableMeta<
        ServiceTemplateScheduleOccurrenceCallbacks,
        ServiceTemplateScheduleOccurrenceTableOptions
    >;
    emptyMessage?: string;
    rowSelection?: RowSelectionState;
    onRowSelectionChange?: OnChangeFn<RowSelectionState>;
    enableRowSelection?: boolean;
    footer?: ReactNode;
    // Backend-driven column sort. Only wired by the drawer; the wizard preview
    // omits these, so its headers render as plain (non-sortable) labels.
    sort?: ServiceTemplateScheduleOccurrencesSortValue;
    onSortChange?: (sort: ServiceTemplateScheduleOccurrencesSortValue) => void;
    onSortRemove?: () => void;
}

export const ServiceTemplateScheduleOccurrencesTable = ({
    rows,
    view = serviceTemplateScheduleOccurrencesView,
    tableMeta,
    emptyMessage = "No upcoming occurrences found.",
    rowSelection,
    onRowSelectionChange,
    enableRowSelection,
    footer,
    sort,
    onSortChange,
    onSortRemove,
}: Props) => (
    <ViewTable
        data={rows}
        view={view}
        config={serviceTemplateScheduleOccurrencesViewConfig}
        tableMeta={tableMeta}
        sort={sort}
        onSortChange={onSortChange}
        onSortRemove={onSortRemove}
        fixedTopOffsetPx
        emptyView={() => <EmptyState header={emptyMessage} />}
        rowSelection={rowSelection}
        onRowSelectionChange={onRowSelectionChange}
        enableRowSelection={enableRowSelection}
        footer={footer}
    />
);
